import * as queries from '@queries/utils';

export const fetchSchedules = () => queries.getQuery('/api/schedules');

export const createSchedules = (schedules) => queries.postQuery('/api/schedules', schedules);

export const updateSchedules = (schedules) => queries.putQuery(`/api/schedules`, schedules);

export const deleteSchedules = (schedulesToDelete) => queries.deleteQuery(`/api/schedules`, schedulesToDelete);